/**
 * OnboardingCelebrationPage — Post-data-entry success moment
 *
 * Shows after the focused data entry phase. Celebrates completion,
 * shows a personalization accuracy message, and transitions to the dashboard.
 */

import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import { completeOnboarding } from "../../services/onboardingService";

export default function OnboardingCelebrationPage() {
  const navigate = useNavigate();
  const { user, updateOnboardingCompleted } = useAuth();

  const handleGoDashboard = useCallback(async () => {
    if (user?.userId) {
      const result = await completeOnboarding(user.userId);
      if (result.ok) {
        updateOnboardingCompleted(true);
      }
    }
    updateOnboardingCompleted(true);
    navigate("/dashboard", { replace: true });
  }, [user, navigate, updateOnboardingCompleted]);

  return (
    <div className="onboarding-celebration" id="onboarding-celebration">
      <div className="onboarding-celebration-content">
        <span className="onboarding-celebration-emoji" aria-hidden="true">
          🎉
        </span>
        <h1 className="onboarding-celebration-heading">You&apos;re all set!</h1>
        <p className="onboarding-celebration-message">
          Your plan is ready. You can always refine it in Settings to improve
          accuracy.
        </p>

        <button
          type="button"
          className="onboarding-celebration-cta"
          onClick={handleGoDashboard}
          aria-label="Go to my dashboard"
        >
          Go to my dashboard →
        </button>
      </div>
    </div>
  );
}
